import {BaseGraphNode} from "#graph/nodes/base/node"
import type {GetParameters} from "#graph/nodes/base/types"
import {CircularRefNodeDefinition} from "#graph/nodes/circular-ref/definition"

export class CircularRef extends BaseGraphNode<typeof CircularRefNodeDefinition> {
    static nodeClass = "CircularRef"
    static definition = CircularRefNodeDefinition
    // Note: Do NOT add `override parameters!:` here - bun's transpiler treats it as
    // a class field that gets initialized to undefined, overwriting the parent's value.
    // TypeScript's narrower type inference from the generic is sufficient.
    declare parameters: GetParameters<typeof CircularRefNodeDefinition>
}
